import '.g{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.cl{background:var(--shades-white);}.ssr-plugin'
import '.bo{flex-grow:1;}.ssr-plugin'
import '.i{align-items:center;}.ssr-plugin'
import '.b8{max-width:77.5rem;}.ssr-plugin'
import '.de{justify-content:stretch;}.ssr-plugin'
import '.df{position:sticky;}.ssr-plugin'
import '.cu{top:0;}.ssr-plugin'
import '.dg{z-index:10;}.ssr-plugin'
import '.dh{padding-block:1rem;}.ssr-plugin'
import '.di{height:3rem;}.ssr-plugin'
import '.a3{justify-content:space-between;}.ssr-plugin'
import '.dj{flex-wrap:wrap;}.ssr-plugin'
import '.dk{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b6{margin-top:2rem;}.ssr-plugin'
import '.dl{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="g ab k h cl"
      >
        <div className="bo g i k h"
        >
          <div className="b8 g h de df cu dg cl"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dh di g a3 i dj"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dk g h ab b6 dl b8"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
